<template>
  <div
    ref="wrapper"
    class="wrapper">
    <main class="main">
      <template v-if="page">
        <template v-for="(module, index) in page.acf.modules">
          <template v-if="module.acf_fc_layout === 'FullImageComponent'">
            <FullImageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'InfoColumnsComponent'">
            <InfoColumnsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'CategorizedNewsComponent'">
            <CategorizedNewsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'CoreDNAComponent'">
            <CoreDNAComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ImageCarouselComponent'">
            <ImageCarouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TextPageComponent'">
            <TextPageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'OpenPositionsComponent'">
            <OpenPositionsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'InvestorsComponent'">
            <InvestorsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'GridComponent'">
            <GridComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TeamComponent'">
            <TeamComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ToggleComponent'">
            <ToggleComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'SpheresCarouselComponent'">
            <SpheresCarouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ScalaPrediActionComponent'">
            <ScalaPrediActionComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'PlatformComponent'">
            <PlatformComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'CirclesTimelineComponent'">
            <CirclesTimelineComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'TitleWithTwoColsComponent'">
            <TitleWithTwoColsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'CtaComponent'">
            <CtaComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'NewsComponent'">
            <NewsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'HeadingComponent'">
            <HeadingComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ThreeBlocksComponent'">
            <ThreeBlocksComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TwoBoxComponent'">
            <TwoBoxComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'HeroModuleComponent'">
            <HeroModuleComponent
              :key="`heroModule-${index}`"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'BlogListComponent'">
            <BlogListComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ImageComponent'">
            <ImageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'SpacerComponent'">
            <SpacerComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'AnchorComponent'">
            <AnchorComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
        </template>
      </template>
    </main>
  </div>
</template>

<script setup>
/* #META
  COMPONENTS - DO NOT ERASE COMMENT
  #ENDMETA */
import FullImageComponent from '@/components/modules/FullImageComponent.vue'
import InfoColumnsComponent from '@/components/modules/InfoColumnsComponent.vue'
import CategorizedNewsComponent from '@/components/modules/CategorizedNewsComponent.vue'
import CoreDNAComponent from '@/components/modules/CoreDNAComponent.vue'
import ImageCarouselComponent from '@/components/modules/ImageCarouselComponent.vue'
import OpenPositionsComponent from '@/components/modules/OpenPositionsComponent.vue'
import TextPageComponent from '@/components/modules/TextPageComponent.vue'
import InvestorsComponent from '@/components/modules/InvestorsComponent.vue'
import GridComponent from '@/components/modules/GridComponent.vue'
import TeamComponent from '@/components/modules/TeamComponent.vue'
import ToggleComponent from '@/components/modules/ToggleComponent.vue'
import SpheresCarouselComponent from '@/components/modules/SpheresCarouselComponent.vue'
import ScalaPrediActionComponent from '@/components/modules/ScalaPrediActionComponent.vue'
import PlatformComponent from '@/components/modules/PlatformComponent.vue'
import CirclesTimelineComponent from '@/components/modules/CirclesTimelineComponent.vue'
import TitleWithTwoColsComponent from '@/components/modules/TitleWithTwoColsComponent.vue'
import CtaComponent from '@/components/modules/CtaComponent.vue'
import NewsComponent from '@/components/modules/NewsComponent.vue'
import HeadingComponent from '@/components/modules/HeadingComponent.vue'
import ThreeBlocksComponent from '@/components/modules/ThreeBlocksComponent.vue'
import HeroModuleComponent from '@/components/modules/HeroModuleComponent.vue'
import TwoBoxComponent from '@/components/modules/TwoBoxComponent.vue'
import AnchorComponent from '@/components/modules/AnchorComponent.vue'
import BlogListComponent from '@/components/modules/BlogListComponent.vue'
import ImageComponent from '@/components/modules/ImageComponent.vue'
import SpacerComponent from '@/components/modules/SpacerComponent.vue'
import { ref, onBeforeMount } from 'vue'
import { useStore } from '@/stores/main'
import useGQL from '@/composables/useGQL.js'

const { gqlQuery } = useGQL()
const store = useStore()
const props = defineProps(['slug', 'isHomepage'])
const page = ref(null)

onBeforeMount(() => {
  getPage()
})

const getPage = async () => {
  let fetchedpage
  if (store.first_impression?.slug === props.slug) {
    fetchedpage = store.first_impression
    page.value = fetchedpage
  } else {
    const data = await gqlQuery(`
      {
        getPagesACF(
          slug: "${props.slug}"
        )
      }
      `)
    fetchedpage = data?.data?.getPagesACF || null
    page.value = fetchedpage
  }
}
</script>

<style lang="scss"></style>
